export const ActionTypes = {
    UPDATE_UPDATE_FOCUS_PRIORITIES: "UPDATE_UPDATE_FOCUS_PRIORITIES_REQUEST",
    UPDATE_UPDATE_FOCUS_PRIORITIES_SUCCESS: "UPDATE_UPDATE_FOCUS_PRIORITIES_SUCCESS",
    UPDATE_UPDATE_FOCUS_PRIORITIES_FAILURE: "UPDATE_UPDATE_FOCUS_PRIORITIES_FAILURE",
}